// import Swiper JS
import Swiper from 'swiper/bundle';

export default {
  init() {
		// JavaScript to be fired on the home page
		// Params
		let mainSliderSelector = '.main-slider',
			navSliderSelector = '.nav-slider',
			certificateSliderSelector = '.certificate-slider';


		// Main Slider
		let mainSliderOptions = {
			parallax: true,
			loop: true,
			speed: 2000,
			autoplay: {
				delay: 4000
			},
			loopAdditionalSlides: 10,
			watchSlidesProgress: true,
			breakpoints: {
				992: {
					allowTouchMove: false,
				}
			},
			on: {
				init() {
				  this.el.addEventListener('mouseenter', () => {
					this.autoplay.stop();
				  });
			
				  this.el.addEventListener('mouseleave', () => {
					this.autoplay.start();
				  });
				}
			  },
		};
		let mainSlider = new Swiper(mainSliderSelector, mainSliderOptions);


		// Navigation Slider
		let navSliderOptions = {
			loop: true,
			loopAdditionalSlides: 10,
			speed:2000,
			spaceBetween: 10,
			centeredSlides : false,
			touchRatio: 0.2,
			slideToClickedSlide: true,
			navigation: {
				nextEl: '.aside-slider-button-next',
				prevEl: '.aside-slider-button-prev',
			},
			breakpoints: {
				0: {
				direction: 'horizontal',
				slidesPerView: 2,
				},
				576: {
				direction: 'horizontal',
				slidesPerView: 3,
				},
				992: {
				direction: 'vertical',
				slidesPerView: 2,
				}
			},
			};
		let navSlider = new Swiper(navSliderSelector, navSliderOptions);

		// Matching sliders
		mainSlider.controller.control = navSlider;
		navSlider.controller.control = mainSlider;


		// Сertificate Slider
		let certificateSliderOptions = {
			// nested: true,
			// loopAdditionalSlides: 10,
			speed: 2000,
			// direction: 'horizontal',
			// centeredSlides : true,
			// touchRatio: 0.2,
			// slideToClickedSlide: true,
			// autoplay: {
			// 	delay: 4000
			// },
			ltr: true,
			loop: true,
			spaceBetween: 22,
			navigation: {
				nextEl: '.certificate-button-next',
				prevEl: '.certificate-button-prev',
			},
			breakpoints: {
				320: {
					slidesPerView: 2,
				},
				576: {
					slidesPerView: 3,
				},
			},
		};
		let certificateSlider = new Swiper(certificateSliderSelector, certificateSliderOptions);
  	},

	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
